import api from '@/api'

const namespaced = true

const state = {
  portStockYards: [],
  portStockYardOverview: []
}

const getters = {
  portStockYards: state => state.portStockYards,
  portStockYardOverview: state => state.portStockYardOverview
}

const mutations = {
  SET_PORT_STOCK_YARDS: (state, payload) => {
    state.portStockYards = payload
  },
  SET_PORT_STOCK_YARD_OVERVIEW: (state, payload) => {
    state.portStockYardOverview = payload
  }
}

const actions = {
  async getPortStockYards({ commit }, payload) {
    try {
      const { data } = await api.getPortStockYard(payload)

      if (data.error) {
        commit('SET_PORT_STOCK_YARDS', [])
        return
      }

      commit('SET_PORT_STOCK_YARDS', data)
    } catch (err) {
      throw err
    }
  },
  async getPortStockYardOverview({ commit }, payload) {
    try {
      const { data } = await api.getPortStockYardOverview(payload)

      if (data.error) {
        commit('SET_PORT_STOCK_YARD_OVERVIEW', [])
        return
      }

      commit('SET_PORT_STOCK_YARD_OVERVIEW', data)
    } catch (err) {
      throw err
    }
  },
  async putPortStockYard({ commit }, payload) {
    try {
      await api.putPortStockYard(payload)
    } catch (err) {
      throw err
    }
  }
}
export default { namespaced, state, getters, mutations, actions }
